import React from "react";
import {  useState } from "react";
import { Row, Col } from "react-bootstrap";
import Popup from "reactjs-popup";
import { RMAItems } from "./types";
import { useActiveRMATypes, useRMADepartmentList, useRMARootCauseList } from "../../../../Store/entities/rmaTypes/hooks";

type AddRMATypeModalProps = {
    openAddRMATypeModal: boolean;
    setOpenAddRMATypeModal: (value: boolean) => void;
    addRmaType: (rmaType: RMAItems) => void;
    primaryDefault?: boolean;
}

const AddRmaTypeModal = ({ openAddRMATypeModal, setOpenAddRMATypeModal, addRmaType, primaryDefault = true }: AddRMATypeModalProps) => {

    const activeRmaTypeOptions = useActiveRMATypes();
    const activeDepartmentOptions = useRMADepartmentList();
    const activeRootCauseOptions = useRMARootCauseList();

    const [selectedRMATypeOptionCode, setSelectedRMATypeOptionCode_R] = useState<string>('');
    const [selectedRMADepartmentCode, setSelectedRMADepartmentCode] = useState<string>('');
    const [selectedRMARootCauseCode, setSelectedRMARootCauseCode] = useState<string>('');
    const [sku, setSku] = useState<string>('');
    const [primary, setPrimary] = useState<boolean>(primaryDefault);

    const setSelectedRMATypeOptionCode = (value: string) => {
        var rmaTypeOption = activeRmaTypeOptions.find((rmaTypeOption) => rmaTypeOption.name === value);
        if (rmaTypeOption) {
            setSelectedRMADepartmentCode(rmaTypeOption.default_department);
            setSelectedRMARootCauseCode(rmaTypeOption.default_root_cause);
        }
        setSelectedRMATypeOptionCode_R(value);
    }

    const rmaTypeOptionsRows = activeRmaTypeOptions
        // Sort by rma type name
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((rmaTypeOption) => {
        return (
            <option key={rmaTypeOption.name} value={rmaTypeOption.name}>
                {rmaTypeOption.name}
            </option>
        )
    });

    const rmaTypeDepartmentsRows = activeDepartmentOptions
        // Sort by department name
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((rmaTypeDepartment) => {
        return (
            <option key={rmaTypeDepartment.name} value={rmaTypeDepartment.name}>
                {rmaTypeDepartment.name}
            </option>
        )
    });

    const rmaTypeRootCausesRows = activeRootCauseOptions
        // Sort by root cause name
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((rmaTypeRootCause) => {
        return (
            <option key={rmaTypeRootCause.name} value={rmaTypeRootCause.name}>
                {rmaTypeRootCause.name}
            </option>
        )
    });



    return (
        <Popup
            open={openAddRMATypeModal}
            onClose={() => setOpenAddRMATypeModal(false)}
            className="mobile-modal"
            closeOnDocumentClick={false}
        >
            <Row>
                <h1>
                    Add RMA Type
                </h1>
            </Row>
            <Row>
                <Col>
                    <Row>
                        <Col>
                            <label>RMAType</label>
                        </Col>
                        <Col>
                            <select value={selectedRMATypeOptionCode} onChange={(e) => setSelectedRMATypeOptionCode(e.target.value)}>
                                <option value=''>Select RMA Type</option>
                                {rmaTypeOptionsRows}
                            </select>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <label >Department</label>
                        </Col>
                        <Col>
                            <select value={selectedRMADepartmentCode} onChange={(e) => setSelectedRMADepartmentCode(e.target.value)}>
                                <option value=''>Select Department</option>
                                {rmaTypeDepartmentsRows}
                            </select>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <label>Root Cause</label>
                        </Col>
                        <Col>
                            <select value={selectedRMARootCauseCode} onChange={(e) => setSelectedRMARootCauseCode(e.target.value)}>
                                <option value=''>Select Root Cause</option>
                                {rmaTypeRootCausesRows}
                            </select>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <label>SKU</label>
                        </Col>
                        <Col>
                            <input type="text" value={sku} onChange={(e) => setSku(e.target.value)} />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <label>Primary</label>
                        </Col>
                        <Col>
                            <input type="checkbox" checked={primary} onChange={(e) => setPrimary(e.target.checked)} />
                        </Col>
                    </Row>
                </Col>
                
            </Row>
            <Row>
                <Col>
                    <button onClick={() => {
                        addRmaType({
                            type_code: selectedRMATypeOptionCode,
                            root_cause: selectedRMARootCauseCode,
                            department: selectedRMADepartmentCode,
                            primary: primary,
                            sku: sku,
                        });

                        setOpenAddRMATypeModal(false)
                    }}>
                        Add
                    </button>

                </Col>
                <Col>
                    <button onClick={() => setOpenAddRMATypeModal(false)}>
                        Cancel
                    </button>
                </Col>

            </Row>
        </Popup>
    )
}


export default AddRmaTypeModal;